import Ajax from './Ajax';
import {Config} from '../../util';

const request = (req) => {
    const payload = {
        class: "mxV10",
        subClass: "MVLS_S",
        command: req.command,
        // userId: ".",
        userId: sessionStorage.getItem('id') || ".", // just for DEV
        userPwd: ".",
        cmdData: req.cmdData 
    };
    return JSON.stringify({root: payload});
}
const API = () => {
    return {

        GetIpAddr: () => {
            Ajax("?");
        },

        CheckLogin: (cmdData) => {
            return Ajax(request({
                command: "CheckLogin",
                cmdData
           }));
        },
        

        

        // Ch
        GetChList: (cmdData) => {
           return Ajax(request({
                command: "GetChList",
                cmdData
           }));
        },
        UpdateChFmt: (cmdData) => {
            return Ajax(request({
                 command: "UpdateChFmt",
                 cmdData
            }));
         },


        SearchEpg: (cmdData) => {
            return Ajax(request({
                command: "SearchEpg",
                cmdData
           }));
        },

        


        SearchVodFile: (cmdData) => {
            return Ajax(request({
                command: "SearchVodFile",
                cmdData
           }));
        },
        SearchLiveCh: (cmdData) => {
            return Ajax(request({
                command: "SearchLiveCh",
                cmdData
           })); 
        },
        PutOrderTrim: (cmdData) => {
            return Ajax(request({
                command: "PutOrderTrim",
                cmdData
            }));
        },
        PutOrderTrim2: (cmdData) => {
            return Ajax(request({
                command: "PutOrderTrim2",
                cmdData
            }));
        },
        GetTrimState: (cmdData) => {
            return Ajax(request({
                command: "GetTrimState",
                cmdData
            }));
        },
        CaptureFrame: (cmdData) => {
            return Ajax(request({
                command: "CaptureFrame",
                cmdData
            }))
        },
        SearchEpgEs: (cmdData) => {
            return Ajax(request({
                command: "SearchEpgEs",
                cmdData
           }));
        },
        GetNextVod: (cmdData) => {
            return Ajax(request({
                command: "GetNextVod",
                cmdData
            }));
        },
        GetPrevVod: (cmdData) => {
            return Ajax(request({
                command: "GetPrevVod",
                cmdData
            }));
        },
        GetVodInfo: (cmdData) => {
            return Ajax(request({
                command: "GetVodInfo",
                cmdData
            }))
        },
        

        // Download Log
        SearchOrdEs: (cmdData) => {
            return Ajax(request({
                command: "SearchOrdDownEs",
                cmdData
            }))
        },
        UpdateOrdDown: (cmdData) => {
            return Ajax(request({
                command: "UpdateOrdDown",
                cmdData
            }))
        },

        // User
        SearchUser: (cmdData) => {
            return Ajax(request({
                command: "SearchUser",
                cmdData
            }))
        },
       

        isInsertUser: (cmdData) => {
            return Ajax(request({
                command: "isInsertUser",
                cmdData
            }))
        },

        UpdateUser: (cmdData) => {
            return Ajax(request({
                command: "UpdateUser",
                cmdData
            }))
        },


        DeleteUser: (cmdData) => {
            return Ajax(request({
                command: "DeleteUser",
                cmdData
            }))
        },

        // Fmt
        SearchFmt: (cmdData) => {
            return Ajax(request({
                command: "SearchFmt",
                cmdData
            }))
        },
        UpdateFmt: (cmdData) => {
            return Ajax(request({
                command: "UpdateFmt",
                cmdData
            }))
        },

        // Path
        SearchPath: (cmdData) => {
            return Ajax(request({
                command: "SearchPath",
                cmdData
            }))
        },
        UpdatePath: (cmdData) => {
            return Ajax(request({
                command: "UpdatePath",
                cmdData
            }))
        },



        // W쇼핑 API

        CheckLoginEx: (cmdData) => {
            return Ajax(request({
                command: "CheckLoginEx",
                cmdData
           }));
        },

        LogoutEx: (cmdData) => {
            return Ajax(request({
                command: "LogoutEx",
                cmdData
           }));
        },

        SearchUserEx: (cmdData) => {
            return Ajax(request({
                command: "SearchUserEx",
                cmdData
            }))
        },
        
        UpdateUserEx: (cmdData) => {
            return Ajax(request({
                command: "UpdateUserEx",
                cmdData
            }))
        },

        SearchEpgWShow: (cmdData) => {
            return Ajax(request({
                command: "SearchEpgWShow",
                cmdData
            }))
        },

        SearchEpgEsWShow: (cmdData) => {
            return Ajax(request({
                command: "SearchEpgEsWShow",
                cmdData
            }))
        },

        WriteConnectLog: (cmdData) => {
            return Ajax(request({
                command: "WriteConnectLog",
                cmdData
            }))
        }

    };
};
export default API();


// WEBPACK FOOTER //
// ./src/util/api/Api.js